import {ApiError, requestJson} from './client'
import type {ScriptDirectory, ScriptDocument, ScriptDraft, ScriptVersion} from '../types/scripts'

export const scriptsApi = {
  list(query = '', cursor = '') {
    const params = new URLSearchParams({q: query, limit: '50'})
    if (cursor) params.set('cursor', cursor)
    return requestJson<ScriptDirectory>(`/api/scripts?${params}`)
  },
  detail(id: string) {return requestJson<{script: ScriptDocument}>(`/api/scripts/detail?${new URLSearchParams({id})}`)},
  create(title: string, projectId = '') {return requestJson<{script: ScriptDocument}>('/api/scripts/create', {title, projectId})},
  save(id: string, revision: number, draft: ScriptDraft) {return requestJson<{script: ScriptDocument}>('/api/scripts/save', {id, revision, ...draft})},
  history(id: string) {return requestJson<{items: ScriptVersion[]}>(`/api/scripts/history?${new URLSearchParams({id})}`)},
  version(id: string, revision: number) {return requestJson<{script: ScriptDocument}>(`/api/scripts/revision?${new URLSearchParams({id, revision: String(revision)})}`)},
  async uploadImage(scriptId: string, file: File): Promise<{imageId: string; width: number; height: number}> {
    const body = new FormData()
    body.append('image', file)
    // Let the browser supply the multipart boundary; use the same workspace cookie transport.
    const response = await fetch(`/api/scripts/${encodeURIComponent(scriptId)}/images`, {method: 'POST', body, credentials: 'same-origin', cache: 'no-store'})
    let data: {imageId?: string; width?: number; height?: number; error?: string; message?: string; code?: string} = {}
    try {data = await response.json()} catch { /* Stable error for proxy/HTML failures. */ }
    if (!response.ok) throw new ApiError(data.error || data.message || '图片上传失败', data.code || 'HTTP_ERROR', response.status)
    if (typeof data.imageId !== 'string' || !/^image-[a-f0-9]{32}$/.test(data.imageId) || typeof data.width !== 'number' || typeof data.height !== 'number') throw new ApiError('图片上传结果无效', 'INVALID_RESPONSE', response.status)
    return {imageId: data.imageId, width: data.width, height: data.height}
  },
  imageUrl(imageId: string): string {return `/api/scripts/images/${encodeURIComponent(imageId)}`},
}
